<template>
  <div class="flex-column">
    <div class="flex-row">
      <div class="data-table-sns-icon-wrap">
        <img
          src="../../assets/ig_icon.png"
          alt
          :class="other_sns['instagram_data'][0] ? 'exist' : ''"
          class="data-table-sns-icon"
        />
      </div>
      <div class="data-table-sns-icon-wrap">
        <img
          src="../../assets/yt_icon.png"
          alt
          :class="other_sns['youtube_data'][0] ? 'exist' : ''"
          class="data-table-sns-icon"
        />
      </div>
      <div class="data-table-sns-icon-wrap">
        <img
          src="../../assets/tt_icon.png"
          alt
          :class="other_sns['tiktok_data'][0] ? 'exist' : ''"
          class="data-table-sns-icon"
        />
      </div>
      <div class="data-table-sns-icon-wrap">
        <img
          src="../../assets/tw_icon.png"
          alt
          :class="other_sns['twitter_data'][0] ? 'exist' : ''"
          class="data-table-sns-icon"
        />
      </div>
    </div>
    <div
      v-if="admin_mode && activate == 20"
      class="admin-button sns pointer"
      style="margin-top: 10px"
      @click="copyCTT()"
    >
      <el-tooltip
        content="[Adminメニュー] SNS連携コードをコピー"
        placement="top"
      >
        <font-awesome-icon :icon="['far', 'code']" />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "snsIconList",
  props: ["other_sns"],
  data() {
    return {};
  },
  computed: {
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {},
  methods: {
    copyCTT() {
      if (this.other_sns["instagram_data"][0])
        var instagram =
          " -i" + this.other_sns["instagram_data"][0]["account_name"];
      else instagram = "";
      if (this.other_sns["youtube_data"][0])
        var youtube = " -y" + this.other_sns["youtube_data"][0]["channel_id"];
      else youtube = "";
      if (this.other_sns["tiktok_data"][0])
        var tiktok = " -t" + this.other_sns["tiktok_data"][0]["account_name"];
      else tiktok = "";
      if (this.other_sns["twitter_data"][0])
        var twitter = " -w" + this.other_sns["twitter_data"][0]["account_name"];
      else twitter = "";
      var text = "php ctt.php" + instagram + youtube + tiktok + twitter + " ";
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "コードがコピーされました",
        });
      });
    },
  },
};
</script>
